import createSentryMiddleware from 'redux-sentry-middleware';
import monitor from 'lib/utils/monitor';
import { isServer } from 'lib/common/constants';

/**
 * Transform the app's state object before sending it to Sentry.
 *
 * @param {object} state
 */
const stateTransformer = (state) => ({
  ...state,

  // contains session cookie token which
  // could be tied back to an individual
  request: null,

  // remove personal information
  session: {
    ...state.session,
    name: null,
    email: null,
  },
});

// noop middleware for use server-side
const noop = () => (next) => (action) => next(action);

const sentryMiddleware = createSentryMiddleware(monitor.Sentry, {
  stateTransformer,
});

const monitorMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case 'GET_SESSION_SUCCESS': {
      monitor.setUser(action.payload.email);
      break;
    }
    default:
      break;
  }
  return sentryMiddleware(store)(next)(action);
};

// raven-for-redux not compatible server-side
// https://github.com/captbaritone/raven-for-redux/issues/76
export default isServer ? noop : monitorMiddleware;
